/**
 * @fileoverview Shared constants to describe the stacking order of CanvasGrid elements
 * and those used across email composition code
 * @owner @Appboy/messaging-experience
 */
import { sideNavZIndex } from "@braze/beacon-labs-navigation";

/**
 * Used to indicate the z-index order of various layers of screens. Includes the
 * Canvas editing stack order since it has the most layers and email composition
 * happens within a canvas
 */
export enum StackOrder {
  /**
   * we include this because of 0-indexing of typescript enums.
   * @note in practice, this should not be used
   */
  BASE = 0,
  /** connections go above any non-stacked content */
  CONNECTION,
  /** ports appear above connections */
  PORT,
  /**
   * any item that appears as part of a modality or contextual facility
   * should be assigned this value, e.g. menus, popovers, modal dialogs, etc
   */
  CONTEXTUAL_ELEMENT,

  /** The z-index used by the pill navigation bar. */
  PILL_NAV = 15,

  /** The z-index used by selects in the Canvas wizard whose options render above the pill navigation bar */
  SELECT_NAV = 16,
  //#region any additional categories and special cases should be inserted here:

  /** The z-index used by the side navigation drawer's backdrop. */
  SIDE_NAVIGATION_DRAWER_BACKDROP = sideNavZIndex - 10,

  /**
   * stacking for non-interop modal content.
   * @note this needs to go above the page chrome elements such as the common nav,
   *   floating header, footer, etc.
   */
  MODAL_CONTENT = 100,

  /** The z-index used by the DND editor within editor framework. */
  DND_EDITOR = 910,

  BEACON_POPPER = 1031,

  /** the modal backdrop needs to be immediately below the modal content */
  INTEROP_MODAL_BACKDROP = 1051,
  /**
   * the modal content needs to be in sync with the modal content rendered by knockout
   * @deprecated use MODAL_CONTENT if the modal content does not need to do a separate
   *   rendering of knockout content
   */
  INTEROP_MODAL_CONTENT = 1052,
  /** used to render a tooltip above modal content */
  INTEROP_MODAL_TOOLTIP = 1053,
  /** used by modal, popover and tooltip etc. */
  OVERLAY_CONTENT = 1062,
  /** used by modal, popover and tooltip etc. that need to render above a popover component */
  OVERLAY_CONTENT_ABOVE_POPOVER = 1064,
  /** must be the highest value so that Braze@Braze modals can appear above all else */
  BRAZE_AT_BRAZE_IAM = 1072,

  //#endregion
}
